import BasePage from "../../../base/BasePage";
import React from "react";
import { addSchemaUseCase } from "../../../usecases/schema/usecases";
import TimeTable from "./time-management-table/TimeTable";
import ManageTimeInOut from "../../../components/TimeManagement";
import TimePresenter from "./time-management-table/TimePresenter";

class TimeManagement extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new TimePresenter(this);
    this.state = {
      progress: false,
      currentDate: new Date(),
      accessPass: false,
      dailyTime: [],
      buttonLabel: "TIME-IN",
      isDisable: false,
    };
    this.childRef = React.createRef();
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.dailyTime !== this.state.dailyTime) {
      this.updateButtonState();
    }
  }

  getCurrentDate() {
    const now = new Date();
    const options = {
      weekday: "long",
      month: "short",
      day: "numeric",
      year: "numeric",
    };
    return now.toLocaleDateString("en-US", options);
  }

  updateButtonState() {
    const { dailyTime } = this.state;
    let buttonLabel = "TIME-IN";
    let isDisable = false;

    if (dailyTime.length > 0) {
      if (
        dailyTime[0].timeOut === "--:--" &&
        dailyTime[0].timeAmOut === "--:--"
      ) {
        buttonLabel = "TIME-OUT";
      } else {
        buttonLabel = "You have already logged out";
        isDisable = true;
      }
    }

    this.setState({ buttonLabel, isDisable });
  }

  handleAccessPass = (access) => {
    this.setState({ accessPass: access });
  };

  closeHandlePass = () => {
    this.setState({ accessPass: false });
  };

  handleDailyTimeUpdate = (data) => {
    this.setState({ dailyTime: data });
  };

  refetchData = () => {
    this.childRef.current.refetchData();
  };

  render() {
    return (
      <>
        <div
          className={`container-fluid d-flex flex-column ${
            this.isMobile() ? "pt-5" : "p-5"
          }`}
          style={{ marginTop: "4rem" }}
        >
          <div
            className="d-flex mb-4"
            style={{ borderBottom: "1px solid #d3d3d3" }}
          >
            <p style={{ fontSize: "14px", color: "grey" }}>
              You are here: Home &gt; Self-service &gt;{" "}
              <span style={{ color: "#333" }}>Time Management</span>
            </p>
          </div>

          <ManageTimeInOut
            dailyTime={[]}
            refetchData={this.refetchData}
            buttonLabel={this.state.buttonLabel}
            isDisable={this.state.isDisable}
          />

          <TimeTable
            ref={this.childRef}
            accessPass={this.handleAccessPass}
            updateDailyTime={this.handleDailyTimeUpdate}
          />
          {/* {this.state.accessPass && (
            <div className="h-100">
              <AccessModal
                closeAccess={this.closeHandlePass}
                refetchData={this.refetchData}
              />
            </div>
          )} */}
        </div>
      </>
    );
  }
}

export default TimeManagement;
